import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import FeaturedArticle from "theme/components/articles/FeaturedArticle";
import CategorySlider from "theme/components/contentBlocks/CategorySlider";
import TextStyles from "theme/components/text/TextStyles";
import BleedWrapper from "theme/components/wrappers/BleedWrapper";
import ArticlesGrid from "theme/views/Article/ArticleGrid";

const HorizontalLine = styled("hr")`
    border: 0.5px solid ${({ theme }) => theme.colors.darkGreige};
    margin: 0;
`;

const ArticleCollectionLayout = ({ response }) => {
    const { t } = useTranslation();
    const { filters = {}, hits: articles = [], handleChange = {}, pagination = {} } = response || {};
    const { hitsCount = 0, page = 0 } = pagination;
    const categories = filters?.category || [];
    const formattedCategories = categories.map((category) => ({
        callback: (e) => {
            e.preventDefault();
            handleChange.filter("category", category.value);
        },
        permalink: `?category=${category.value}`,
        selected: category.selected,
        title: category.value,
    }));

    const isFirstModulePage = page === 0;
    const featuredArticle = isFirstModulePage && articles?.length && articles[0];

    return (
        <>
            <BleedWrapper>
                <CategorySlider textStyles="Myriad Pro/16-120" slidesPerView={6.5} categories={formattedCategories} />
            </BleedWrapper>
            <HorizontalLine />
            {featuredArticle && (
                <>
                    <TextStyles textStyles={["Buenos Aires/14-120 Regular"]} m="16px 0" opacity={0.6}>
                        {t(hitsCount === 1 ? "articles.articles_count" : "articles.articles_count_plural", {
                            count: hitsCount,
                        })}
                    </TextStyles>
                    <FeaturedArticle {...featuredArticle} />
                </>
            )}
            <ArticlesGrid response={response} />
        </>
    );
};

ArticleCollectionLayout.propTypes = {
    response: PropTypes.shape({
        articles: PropTypes.array,
        filters: PropTypes.object.isRequired,
        handleChange: PropTypes.shape({
            filter: PropTypes.func,
            clearFilter: PropTypes.func,
        }),
        pagination: PropTypes.shape({
            hitsCount: PropTypes.number,
            page: PropTypes.number,
        }),
        tags: PropTypes.arrayOf(PropTypes.string),
    }),
};

ArticleCollectionLayout.defaultProps = {
    response: {
        filters: {},
        handleChange: {
            filter: () => null,
        },
    },
};

export default ArticleCollectionLayout;
